import { useState } from "react"
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch"

interface ZoomableImageProps {
    src: string
    alt?: string
    className?: string
}

export default function ZoomableImage({ src, alt = "image", className = "" }: ZoomableImageProps) {

    const [dragCursorIsShown, setDragCursorIsShown] = useState<boolean>(false)

    return (
        <div className={`zoomable-image-wrapper ${className}`}
            style={dragCursorIsShown ? {cursor: "grab"} : {cursor: "zoom-in"}}
        >
            <TransformWrapper
                initialScale={1}
                minScale={0.5}
                maxScale={5}
                wheel={{ step: 0.2 }}
                doubleClick={{ disabled: false, mode: "zoomIn" }}
                pinch={{ step: 5 }}
                onZoom={(event) => setDragCursorIsShown(event.state.scale > 1)}
            >
                <TransformComponent wrapperStyle={{ width: "100%", height: "100%" }}>
                    <img
                        src={src}
                        alt={alt}
                        style={{ width: "100%", height: "auto", userSelect: "none" }}
                    />
                </TransformComponent>
            </TransformWrapper>
        </div>
    )
}